import { render, staticRenderFns } from "./Scene4.vue?vue&type=template&id=78e207a1&scoped=true"
import script from "./Scene4.vue?vue&type=script&lang=js"
export * from "./Scene4.vue?vue&type=script&lang=js"
import style0 from "./Scene4.vue?vue&type=style&index=0&id=78e207a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e207a1",
  null
  
)

export default component.exports